// official config

export const SET_FEEDBACK_LIST = 'SET_FEEDBACK_LIST'
export const SET_FEEDBACK_LIST_PAGE = 'SET_FEEDBACK_LIST_PAGE'
export const SET_FEEDBACK_LIST_PAGE_TOTAL = 'SET_FEEDBACK_LIST_PAGE_TOTAL'
export const SET_FEEDBACK_LIST_PAGE_COUNT = 'SET_FEEDBACK_LIST_PAGE_COUNT'
export const SET_FEEDBACK_LIST_PAGE_SIZE = 'SET_FEEDBACK_LIST_PAGE_SIZE'

// user-research
export const SET_USER_RESEARCH_LIST = 'SET_USER_RESEARCH_LIST'
export const SET_USER_RESEARCH_LIST_SEARCHING = 'SET_USER_RESEARCH_LIST_SEARCHING'
export const SET_USER_RESEARCH_LIST_LOADING = 'SET_USER_RESEARCH_LIST_LOADING'
export const SET_USER_RESEARCH_LIST_PAGE_TOTAL = 'SET_USER_RESEARCH_LIST_PAGE_TOTAL'
export const SET_USER_RESEARCH_LIST_PAGE_SIZE = 'SET_USER_RESEARCH_LIST_PAGE_SIZE'
export const SET_USER_RESEARCH_LIST_PAGE_NUM = 'SET_USER_RESEARCH_LIST_PAGE_NUM'

export const SET_PROJECT_LIST = 'SET_PROJECT_LIST'
export const SET_PROJECT_LIST_PAGE_TOTAL = 'SET_PROJECT_LIST_PAGE_TOTAL'
export const SET_PROJECT_LIST_PAGE_SIZE = 'SET_PROJECT_LIST_PAGE_SIZE'
export const SET_PROJECT_LIST_PAGE_NUM = 'SET_PROJECT_LIST_PAGE_NUM'
export const SET_QUETSIONNAIREID_NAME_LIST = 'SET_QUETSIONNAIREID_NAME_LIST'

export const SET_VIEW_DATA_LIST = 'SET_VIEW_DATA_LIST'
export const SET_VIEW_DATA_LIST_QUERY = 'SET_VIEW_DATA_LIST_QUERY'
export const SET_VIEW_DATA_LIST_SEARCHING = 'SET_VIEW_DATA_LIST_SEARCHING'
export const SET_VIEW_DATA_LIST_PAGE_TOTAL = 'SET_VIEW_DATA_LIST_PAGE_TOTAL'
export const SET_VIEW_DATA_LIST_PAGE_NUM = 'SET_VIEW_DATA_LIST_PAGE_NUM'
export const SET_VIEW_DATA_LIST_PAGE_SIZE = 'SET_VIEW_DATA_LIST_PAGE_SIZE'
